<template>
    <v-dialog
        v-model="showDialog"
        width="800"
        style="z-index: 250"
    >
        <v-card v-if="data && data.HISTORY">
            <v-card-title style="background-color: #009688; color: white; word-break: break-word;">
                History for: {{ data.ACU_ACCOUNT }}
            </v-card-title>
            <v-card-text style="padding-top: 30px;">
                <v-textarea
                    readonly
                    outlined
                    :value="data.HISTORY"
                    hide-details
                />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    class="white--text"
                    color="#009688"
                    @click="showDialog = false"
                >
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: ['show', 'data'],
    computed: {
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        }
    }
}
</script>
